import React, { FC, useState, useCallback, useContext } from 'react'
import { isMobile } from 'react-device-detect'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericIcon from '../../../GenericComponents/GenericIcon'

import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import { PdfTIle } from '../style/AlbumScreenStyle'
import pdfDownloadIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/pdf-download-icon.svg'
import pdfIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/pdf-icon.svg'

interface DocumentationModeInterface {
  albumName: string
  pdfUrls: any
}

const DocumentationMode: FC<DocumentationModeInterface> = ({
  albumName,
  pdfUrls,
}) => {
  return (
    <GenericMainCard
      margin={'5% auto 0 auto'}
      maxWidth={'1000px'}
      className="standard"
      width={isMobile ? '95%' : '50%'}
      flexDir="column"
    >
      <GenericTextSpan fSize={'1.6rem'} margin={'0 0 5% 0'}>
        {albumName && albumName}
      </GenericTextSpan>

      <GenericColumn>
        {pdfUrls &&
          pdfUrls.map((pdf: any) => (
            <PdfTIle>
              <GenericRow width={'70%'} justify={'flex-start'}>
                <GenericTextSpan>{pdf.name}</GenericTextSpan>
              </GenericRow>
              <GenericRow width={'30%'} justify={'flex-end'}>
                <GenericIcon
                  width={isMobile ? '3.5vw' : '1vw'}
                  height={isMobile ? '3.5vw' : '1vw'}
                  src={pdfIcon}
                />
                <GenericIcon
                  margin={'0 0 0 10%'}
                  className={'button-style'}
                  onClick={() => window.open(pdf.url, '_blank')}
                  width={isMobile ? '3.5vw' : '1vw'}
                  height={isMobile ? '3.5vw' : '1vw'}
                  src={pdfDownloadIcon}
                />
              </GenericRow>
            </PdfTIle>
          ))}
      </GenericColumn>
    </GenericMainCard>
  )
}

export default DocumentationMode
